<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/M7Lcih/image/cover.jpg?1731429793732" alt="This image is the cover for the book Outside the Charmed Circle"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Outside the Charmed Circle
      </h1>
      <p class="bookDescription body article font2">
        <p>The intention of <i>Outside the Charmed Circle</i> is to help readers live as the truest expression of their gendered, sexual, spiritual self. It is designed to support you as you awaken to who you are, deepen your magical practice, and walk through the Pagan world. Author Misha Magdalene provides hands-on meditations, prompts, and magical workings to help you explore your identity as it intersects with your spiritual practice. With thoughtful insights on embodiment, consent, and Eros, as well as explorations of self-esteem, ability, disability, and your feelings about your body, this book helps those in the LGBTQIA+ community and their allies engage with a wide range of identities in a magical setting.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Misha Magdalene, Michelle Belanger
      </h2>
      
      <p class="authorDescription body article"><P><B>Misha Magdalene</B> (they/them) is a multidisciplinary, multi-classed, multiqueer witch. They are an initiate of three lineages of traditional witchcraft: Anderson Feri, Gardnerian Wicca, and Central Valley Wicca. They hold a degree in gender, women, and sexuality studies from the University of Washington. Misha is the recipient of the Leslie Ashbaught Feminist Praxis in Education Award. They live near Seattle, Washington.</P><P><B>Michelle Belanger</B> is an occult expert, educator, media personality, and author of over thirty books on paranormal and occult topics. Founder and lead clergy of the magickal group House Kheperu, Belanger is most widely recognized for work as a psychic on A&E's <I>Paranormal State</I> and Osbourne Media's <I>Portals to Hell</I>. Consulted for numerous documentaries, books, and courses, Belanger has lectured on paranormal and occult topics at colleges and universities across North America and was a National Merit Scholar. A prolific and versatile creator, Belanger has also contributed work to projects as wide-ranging as Marvel AR, HBO's <I>True Blood</I>, CNN Headline News, <I>CSI</I>, Nox Arcana, and multiple RPGs.</P><P>To learn more about Belanger's work, start by exploring www.MichelleBelanger.com, where you'll find classes, books, music, and events at the retreat center, Inspiration House. Follow Belanger on Twitter, YouTube, Facebook, and Instagram under the handle sethanikeem.</P>~</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Llewellyn Publications is an imprint of Llewellyn Worldwide Ltd. 
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?690c6eca